import * as React from 'react';
import { ErrorNotification, SuccessNotification } from '@verclam/toast-v2';

/**
 * `eventName` matches the `type` of the actions dispatched by `Application/BeneficiaryContacts/**`.
 * Lives at the root of this screen, not in `Beneficiaries/Shared/`: these listeners have a single
 * consumer, and `Shared/BeneficiariesNotifications.tsx` explicitly bounds its own scope to
 * `Application/Beneficiaries/**`, which the contacts are not.
 */
const BeneficiaryContactsNotifications: React.FC = () => {
	return (
		<React.Fragment>
			<SuccessNotification
				eventName="BENEFICIARY_CONTACT_CREATED"
				title="Contact créé"
				message="Le contact a bien été créé."
			/>
			<SuccessNotification
				eventName="BENEFICIARY_CONTACT_UPDATED"
				title="Contact modifié"
				message="Le contact a bien été modifié."
			/>
			<SuccessNotification
				eventName="BENEFICIARY_CONTACT_DELETED"
				title="Contact supprimé"
				message="Le contact a bien été supprimé."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_CONTACTS_FETCH_FAILED"
				title="Erreur"
				message="La liste des contacts n'a pas pu être chargée."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_CONTACT_CREATION_FAILED"
				title="Erreur"
				message="Le contact n'a pas pu être créé."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_CONTACT_UPDATE_FAILED"
				title="Erreur"
				message="Le contact n'a pas pu être modifié."
			/>
			<ErrorNotification
				eventName="BENEFICIARY_CONTACT_DELETION_FAILED"
				title="Erreur"
				message="Le contact n'a pas pu être supprimé."
			/>
		</React.Fragment>
	);
};

export default BeneficiaryContactsNotifications;
